<template>
  <div>
    <Layout/>
<!-- Breadcrumb y ayuda -->    
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/interconsulta">Interconsultas</router-link> >
            <router-link :to="'/interconsultadestinoform/'+p_idAtencion+'/'+p_idInterconsulta"> Paciente: {{ datoInterconsulta.paciente }}</router-link> 
            > Informe
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <hr>

    <button @click.prevent="mostrarOcultarBloqueAtencion">(+/-) Información General</button>
    <div v-if="mostrarBloqueAtencion" class="mb-3">

    <div class="mb-3">
      <div class="row">
        <div class="col-1">
          <label for="medicoAtencion" class="form-label">Médico</label>
        </div>
        <div class="col-5">
          <input type="text" class="form-control" id="medicoAtencion" name="medicoAtencion  " v-model="datoInterconsulta.medicoAtencion" disabled>                    
        </div>
        <div class="col-1">
          <label for="estadoInter" class="form-label">Estado</label>
        </div>
        <div class="col-5">
          <input type="text" class="form-control" id="estadoInter" name="estadoInter" v-model="datoInterconsulta.estadoInter" disabled>                    
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col-1">
          <label for="motivo" class="form-label">Motivo</label>
        </div>
        <div class="col-11">
          <textarea class="form-control" id="motivo" name="motivo" v-model="datoInterconsulta.motivo" disabled></textarea>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col-1">
          <label for="cuadro" class="form-label">Cuadro</label>
        </div>
        <div class="col-11">
        <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInterconsulta.cuadro" disabled></textarea>
        </div>
      </div>
    </div>

    </div>

    <hr>

<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
          <div class="mb-3">
                <div class="mb-3">
              <div class="row">
                <div class="col-6">
                  <label for="cuadro" class="form-label">Cuadro</label>
                  <div class="input-group">
                    <textarea class="form-control" id="cuadro" name="cuadro" v-model="datoInformeInter.cuadro" style='text-transform:uppercase'></textarea>
                    <button v-if="!isDictatingCuadro" class="btn btn-outline-secondary" type="button" @click="startDictation('cuadro')" :disabled="isDictatingResumen || isDictatingPlanDiagnostico || isDictatingPlanTerapeutico">
                      <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                    </button>
                    <button v-else class="btn btn-outline-secondary" type="button" @click="stopDictation('cuadro')">
                      <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                    </button>
                  </div>
                </div>
                <div class="col-6">
                  <label for="resumen" class="form-label">Resumen</label>
                  <div class="input-group">
                    <textarea class="form-control" id="resumen" name="resumen" v-model="datoInformeInter.resumen" style='text-transform:uppercase'></textarea>
                    <button v-if="!isDictatingResumen" class="btn btn-outline-secondary" type="button" @click="startDictation('resumen')" :disabled="isDictatingCuadro || isDictatingPlanDiagnostico || isDictatingPlanTerapeutico">
                      <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                    </button>
                    <button v-else class="btn btn-outline-secondary" type="button" @click="stopDictation('resumen')">
                      <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>              
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-6">
                  <label for="planDiag" class="form-label">Plan Diagnóstico</label>
                  <div class="input-group">
                    <textarea class="form-control" id="planDiag" name="planDiag" v-model="datoInformeInter.planDiag" style='text-transform:uppercase'></textarea>
                    <button v-if="!isDictatingPlanDiagnostico" class="btn btn-outline-secondary" type="button" @click="startDictation('planDiag')" :disabled="isDictatingCuadro || isDictatingResumen || isDictatingPlanTerapeutico">
                      <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                    </button>
                    <button v-else class="btn btn-outline-secondary" type="button" @click="stopDictation('planDiag')">
                      <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                    </button>
                  </div>
                </div>
                <div class="col-6">
                  <label for="planTera" class="form-label">Plan Terapéutico</label>
                  <div class="input-group">
                    <textarea class="form-control" id="planTera" name="planTera" v-model="datoInformeInter.planTera" style='text-transform:uppercase'></textarea>
                    <button v-if="!isDictatingPlanTerapeutico" class="btn btn-outline-secondary" type="button" @click="startDictation('planTera')" :disabled="isDictatingCuadro || isDictatingResumen || isDictatingPlanDiagnostico">
                      <span class="material-symbols-outlined" style="font-size:40px;color:orangered; cursor: pointer;">mic_off</span>
                    </button>
                    <button v-else class="btn btn-outline-secondary" type="button" @click="stopDictation('planTera')">
                      <span class="material-symbols-outlined" style="font-size:40px;color:green; cursor: pointer;">mic</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">Fecha Registro</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="fechaReg" name="fechaReg" :value="getFormattedDate(datoInformeInter.fechaReg)" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idInformeInter" class="form-label">IdInformeInter</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="idInformeInter" name="idInformeInter" v-model="datoInformeInter.idInformeInter" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idInterconsulta" class="form-label">IdInterconsulta</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="idInterconsulta" name="idInterconsulta" v-model="datoInformeInter.idInterconsulta" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditInformeInter" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i> Actualizar
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="actualizarEstado('FINALIZADA')" title="Finalizar Interconsulta">
          <span class="material-symbols-outlined" style="font-size:32px;color:green; cursor: pointer;">task_alt</span>
          Finalizar Interconsulta
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
<!--       
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
 --> 
<!--       
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
 -->  
<!--       
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
 -->  
<!--       
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
 -->  
<!--       
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
 -->  
<!--       
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
 -->  
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>Registrar Diagnósticos  
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Tipo</th>
          <th scope="col">Código</th>
          <th scope="col">Nombre</th>
          <th scope="col">Observación</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="diaginter in datosPaginados" :key="diaginter.idDiagInter">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(diaginter.idDiagInter)" title="Editar">edit_square</i></td>
          <td>{{ diaginter.tipo }}</td>
          <td>{{ diaginter.diagnosticoCodigo }}</td>
          <td>{{diaginter.diagnosticoNombre}}</td>
          <td>{{diaginter.observacion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteInformeInter(diaginter.idDiagInter)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
<!--             <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idDiagInter" class="form-label">IdDiagInter</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idDiagInter" name="idDiagInter" v-model="datoDiagInter.idDiagInter" disabled>
                </div>
              </div>
            </div> -->
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idDiagnostico" class="form-label">Diagnóstico</label>
                  </div>
                  <div class="col-10">
                    <div class="input-group">
                      <input type="text" 
                            class="form-control" 
                            v-model="searchTextDiag" 
                            @input="filterDiagnosticos"
                            placeholder="Buscar diagnóstico...">
                      <button class="btn btn-outline-secondary dropdown-toggle" 
                              type="button" 
                              data-bs-toggle="dropdown" 
                              aria-expanded="false">
                        <i class="fa fa-search"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" style="max-height: 200px; overflow-y: auto;">
                        <li v-for="diagnostico in filteredDiagnosticos" :key="diagnostico.idDiagnostico">
                          <a class="dropdown-item" href="#" @click.prevent="selectDiagnostico(diagnostico)">
                            {{ diagnostico.codigo }} - {{ diagnostico.nombre }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipo" class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                  <select class="form-control" id="tipo" name="tipo" v-model="datoDiagInter.tipo" required>
                    <option value="">Seleccione una opción</option>
                    <option value="Presuntivo">Presuntivo</option>
                    <option value="Definitivo">Definitivo</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="observacion" name="observacion" v-model="datoDiagInter.observacion" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="informeInterFechaReg" class="form-label">Fecha Registro</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="informeInterFechaReg" name="informeInterFechaReg" :value="getFormattedDate(datoDiagInter.informeInterFechaReg)" disabled>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarDiagInter" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditDiagInter" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->



    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import SpeechDictation from '@/modules/microfono.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      datoInterconsulta : {},
// Variables master
      informeinters : [],
      datoInformeInter : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idInformeInter: '',
      interconsultas : [],
// Variables master
//      p_Opcion: 0,
      p_idAtencion: 0,
      p_idInterconsulta: 0,
      mostrarBloqueAtencion: false,
      mostrarBloque: false,
      // filtroDiagnostico: '',      
      filteredDiagnosticos: [],
      selectedDiagnostico: null,
// Variables details
      diaginters : [],
      datoDiagInter : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      diagnosticos : [],
//      informeInters : [],
      modalWindow: true,
// Variables details
      dictation: new SpeechDictation(),
      isDictatingCuadro: false,
      isDictatingResumen: false,
      isDictatingPlanDiagnostico: false,
      isDictatingPlanTerapeutico: false
    }
  },
  async mounted () {
//    this.p_Opcion = this.$route.params.p_opcion
    this.p_idAtencion = this.$route.params.p_idatencion
    this.p_idInterconsulta = this.$route.params.p_idinterconsulta
    this.getData()
    await this.abrirEditar()
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchDiagnosticos()
//    this.fetchInterconsultas()
//    this.filteredDiagnosticos = [...this.diagnosticos];
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloqueAtencion() {
      this.mostrarBloqueAtencion = !this.mostrarBloqueAtencion;
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
      ];
      const requiredFieldsText = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
      ];
      return validarForm(this.datoInformeInter, requiredFields, requiredFieldsText);
    },
    getData() {
      api.get('/vwinterconsultas/destino/'+this.p_idInterconsulta)
        .then(response => {
          this.datoInterconsulta = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    },
    async guardarEditInformeInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/informeinters', this.datoInformeInter)
          swal("Correcto!", "InformeInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array01 = Object.values(error.response.data.errors)
          array01.forEach(element => swal(String(element)))
        }
        try {
          await api.put('/interconsultas/actualizar-estado/'+this.p_idInterconsulta+'/PROCESO')
          swal("Correcto!", "InformeInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array02 = Object.values(error.response.data.errors)
          array02.forEach(element => swal(String(element)))
        }
      }
    },
    async actualizarEstado(estado){
      if(this.validarForm() === 1){
        try {
          await api.put('/interconsultas/actualizar-estado/'+this.p_idInterconsulta+'/'+estado)
          swal("Correcto!", "Informe actualizado!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
        this.$router.push('/interconsulta');
      }
    },
    async abrirEditar(){
//      this.modalWindow = true
      await api.get('/vwinformeinters/idinterconsulta/'+this.p_idInterconsulta).then(resp => {
        this.datoInformeInter = resp.data;
      }).catch(error => {
        console.error('Error al obtener los datos:', error);
      });
    },
    cerrarInformeInter(){
      this.$router.push('/InformeInter')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.diaginters.length / this.elementosPorPagina)
    },
    async  getDataPaginaTodos(noPagina){
      await api.get('/vwdiaginters/idinformeinter/'+this.datoInformeInter.idInformeInter).then(response=>{
      this.diaginters=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.diaginters.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },    
    validarFormDet(){
      const requiredFields = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
      ];
      const requiredFieldsText = [
        'idInterconsulta'
        ,'cuadro'
        ,'resumen'
        ,'planDiag'
        ,'planTera'
      ];
      return validarForm(this.datoInformeInter, requiredFields, requiredFieldsText);
    },
    async guardarDiagInter(){
      if(this.validarForm() === 1){
        try {
          this.datoDiagInter.idInformeInter = this.datoInformeInter.idInformeInter;
          await api.post('/diaginters', this.datoDiagInter)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "DiagInter creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditDiagInter(){
      if(this.validarForm() === 1){
        try {
          await api.post('/diaginters', this.datoDiagInter)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "DiagInter creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoDiagInter={}
      this.titulo   = 'Registrar Diagnóstico'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idDiagInter){
      this.modalWindow = true
      if(idDiagInter != null){    
           api.get('/vwdiaginters/'+idDiagInter).then(resp=>{
          this.datoDiagInter = resp.data;
          this.searchTextDiag = `${resp.data.diagnosticoCodigo} - ${resp.data.diagnosticoNombre}`;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Diagnóstico'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idDiagInter){
      this.modalWindow = true
      if(idDiagInter != null){
        this.$router.push('/diagintermd/'+idDiagInter)
      }
    },
    async deleteDiagInter (idDiagInter) {
      try{
        await api.delete('/diaginters/'+idDiagInter)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    }, 
    fetchDiagnosticos() {
      fetch('http://localhost:8080/api/v1/vwdiagnosticos')
        .then(response => response.json())
        .then(data => {
          this.diagnosticos = data;
          this.filteredDiagnosticos = this.diagnosticos;
        })
        .catch(error => {
          console.error('Error fetching diagnosticos:', error);
        });
    },
    filterDiagnosticos() {
      if (!this.searchTextDiag) {
        this.filteredDiagnosticos = [];
      } else {
        this.filteredDiagnosticos = this.diagnosticos.filter(diagnostico =>
          diagnostico.nombre.toLowerCase().includes(this.searchTextDiag.toLowerCase()) ||
          diagnostico.codigo.toLowerCase().includes(this.searchTextDiag.toLowerCase())
        );
      }
    },
    selectDiagnostico(diagnostico) {
      this.datoDiagInter.idDiagnostico = diagnostico.idDiagnostico;
      this.searchTextDiag = `${diagnostico.codigo} - ${diagnostico.nombre}`; // Asegura que esto actualiza la UI
    },
      startDictation(field) {
        this.dictation.startDictation((transcript) => {
          this.datoInformeInter[field] = transcript;
        }, this.datoInformeInter[field]);
        if(field=="cuadro"){
          this.isDictatingCuadro = true;
        }
        else if(field=="resumen"){
          this.isDictatingResumen = true;
        }
        else if(field=="planDiag"){
          this.isDictatingPlanDiagnostico = true;
        }
        else if(field=="planTera"){
          this.isDictatingPlanTerapeutico = true;
        }
      },
    stopDictation(field) {
      this.dictation.stopDictation();
      if(field=="cuadro"){
        this.isDictatingCuadro = false;
      }
      else if(field=="resumen"){
        this.isDictatingResumen = false;
      }
      else if(field=="planDiag"){
        this.isDictatingPlanDiagnostico = false;
      }
      else if(field=="planTera"){
        this.isDictatingPlanTerapeutico = false;
      }
    }
  },
}
</script>
<style scoped>
.input-group .dropdown-menu {
  width: 100%;
}
.dropdown-item {
  cursor: pointer;
}
</style>
<style src="@/assets/css/microfono.css" scoped></style>